import { createFileRoute } from '@tanstack/react-router';
import { QueryTab } from '@/pages/workspaces/journeys/integrations/sql-sync/import/tabs/query-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

/** The Query tab: edit and re-run the import's query. */
export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/integrations/sql-sync/$type/$sqlImportId/query',
)({
  component: withRumPageRendered(QueryTab),
});
